import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { Building2, LogIn } from 'lucide-react';
import CommercialGate from './CommercialGate';

interface AuthGuardProps {
  children: React.ReactNode;
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center text-white">
          <Building2 size={48} className="mx-auto mb-4 text-blue-400 animate-pulse" />
          <p className="text-xl">טוען...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center" dir="rtl">
        <div className="text-center max-w-md mx-auto p-8">
          <Building2 size={64} className="mx-auto mb-6 text-blue-400" />
          <h2 className="text-2xl font-bold mb-4">נדרשת התחברות</h2>
          <p className="text-gray-300 mb-6">
            כדי להשתמש במערכת, יש להתחבר תחילה
          </p>
          <div className="space-y-4">
            <button
              onClick={() => navigate('/login')}
              className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
            >
              <LogIn size={20} />
              התחברות
            </button>
            <p className="text-sm text-gray-400">
              אין לך חשבון?{' '}
              <a href="/register" className="text-blue-400 hover:text-blue-300">הרשמה</a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return <CommercialGate>{children}</CommercialGate>;
}